// extracted by mini-css-extract-plugin
export var cardIcon = "_8a-4";
export var checkboxCard = "_8a-0";
export var checkboxCardSelected = "_8a-3";
export var disabled = "_8a-1";
export var outerBorder = "_8a-2";
export var spacerMedium = "_8a-7";
export var spacerSmall = "_8a-6";
export var spacerXsmall = "_8a-5";